import React from "react";

const GardenIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 21.325a6 6 0 0 1-6-6 6 6 0 0 1 6 6m0 0a6 6 0 0 0 6-6 6 6 0 0 0-6 6m0 0v-10m0 0a5 5 0 0 1-5-5v-3l3 2 2-2 2 2 3-2v3a5 5 0 0 1-5 5"
    ></path>
  </svg>
);

export default GardenIcon;
